/**
 * The web pages an assistant message cited, as a collapsed "Used N sources"
 * disclosure under the reply.
 *
 * The agent's own prose usually links inline; this is the complete, provider-
 * reported list — every `url_citation` OpenAI's hosted `web_search` attached to
 * the answer (and the equivalent grounding chunks from Gemini's
 * `google_search`). Collapsed by default so a heavily-searched turn doesn't bury
 * its own answer.
 */
import {
  Source,
  Sources,
  SourcesContent,
  SourcesTrigger,
} from "../ai-elements/sources";
import type { MessageSource } from "./body-items";

export function MessageSources({ sources }: { sources: MessageSource[] }) {
  return (
    <Sources className="mb-0 text-muted-foreground">
      <SourcesTrigger
        count={sources.length}
        className="hover:text-foreground"
      />
      <SourcesContent className="max-w-full">
        {sources.map((s) => (
          <Source
            key={s.url}
            href={s.url}
            title={s.label}
            className="max-w-full hover:text-foreground [&>span]:truncate [&>svg]:shrink-0"
          />
        ))}
      </SourcesContent>
    </Sources>
  );
}
